var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',_vm._l((_vm.scenario.select),function(sel,i){return _c('path',{key:i,staticClass:"path",attrs:{"d":_vm.makePath(_vm.scenario, sel, i),"fill":"none","stroke":_vm.makePathColor(i),"opacity":_vm.strokeOpacity,"stroke-width":_vm.strokeWidth},on:{"mouseover":function($event){return _vm.changeColor(i)},"mouseleave":function($event){return _vm.changeColor(-1)},"click":function($event){return _vm.deleteNode(i)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae9300e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Top/ConnectPathDemo.vue
// module id = null
// module chunks = 